import $ from 'jquery'

class Home {

  constructor() {
    this.init()
  }


  init() {

    this.feature = $('.feature a')
    this.background = $('.backgrounds')
    this.contact = $('.contact')

    this.addEvents()

  }

  addEvents() {

    $('.contact__link').on('click', (e)=>{
      e.preventDefault()
    })

    this.feature.on('mouseenter', (e)=>{
      const color = $(e.currentTarget).data('background')
      $(e.currentTarget).addClass('is-active')
      this.background.addClass(color)

    })
    this.feature.on('mouseleave', (e)=>{
      const color = $(e.currentTarget).data('background')
      $(e.currentTarget).removeClass('is-active')
      this.background.removeClass(color)
    })

    this.contact.on('mouseenter', (e)=>{
      $('.contact__container').addClass('is-active')
    })
    this.contact.on('mouseleave', (e)=>{
      $('.contact__container').removeClass('is-active')
    })
  }

  destroy(){
    this.feature.off('click')
    this.feature.off('mouseenter')
    this.feature.off('mouseleave')

  }

}

module.exports = Home
